export const RECEIVE_EXTRACT = 'RECEIVE_EXTRACT'
export const RECEIVE_EXTRACT_LEVEL_TWO = 'RECEIVE_EXTRACT_LEVEL_TWO'
export const RECEIVE_EXTRACT_LEVEL_THREE = 'RECEIVE_EXTRACT_LEVEL_THREE'
export const FETCH_EXTRACT = 'FETCH_EXTRACT'
export const FETCH_EXTRACT_LEVEL_TWO = 'FETCH_EXTRACT_LEVEL_TWO'
export const FETCH_EXTRACT_LEVEL_THREE = 'FETCH_EXTRACT_LEVEL_THREE'
export const RECEIVE_CURRENT_EXTRACTS = 'RECEIVE_CURRENT_EXTRACTS'
export const RECEIVE_CURRENT_EXTRACT = 'RECEIVE_CURRENT_EXTRACT'
export const RECEIVE_PRODUCT = 'RECEIVE_PRODUCT'
export const CLEAR_EXTRACT = 'CLEAR_EXTRACT'
export const CLEAR_EXTRACT_LEVEL_THREE = 'CLEAR_EXTRACT_LEVEL_THREE'
